module.exports = __webpack_public_path__ + "img/nothing.31322c47.webp";